import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Skeleton } from 'antd'
import { getCubeAPI } from '../../../../../../Cube'
import { QueryRenderer } from '@cubejs-client/react'
import { ReportFilterStore } from '../../ReportFilterStore'
import { GrPrice } from '../../../../../../utilities/helpers'

interface Props {
  companyId: number
  reportFilterStore?: ReportFilterStore
}

interface State {
  fullQuery: any
}

@inject('reportFilterStore')
@observer
export class PurchaseOrderCount extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      fullQuery: undefined,
    }
  }

  componentDidMount = () => this.setQuery()

  setQuery = () => {
    const reportFilterStore = this.props.reportFilterStore!

    const fullQuery = {
      measures: ['Invoices.count', 'Invoices.total'],
      timeDimensions: [
        {
          dimension: 'Invoices.completedate',
          granularity: null,
          dateRange: [reportFilterStore.startDateString, reportFilterStore.endDateString],
        },
      ],
      filters: [
        {
          dimension: 'Invoices.status',
          operator: 'equals',
          values: ['completed'],
        },
        {
          dimension: 'Invoices.locationId',
          operator: 'equals',
          values: reportFilterStore.selectedLocationIds.map((id) => `${id}`),
        },
      ],
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }

    this.setState({ fullQuery })
  }

  renderChart = ({ resultSet, error }: any) => {
    return (
      (resultSet && (
        <>
          <h2 className='mb-1'>
            {GrPrice.convertDollarToDollar(resultSet.chartPivot()[0]['Invoices.total'])}
          </h2>
          <div className='text-muted'>
            {resultSet.chartPivot()[0]['Invoices.count']} purchase orders
          </div>
        </>
      )) ||
      (error && error.toString()) || <Skeleton active />
    )
  }

  render() {
    const { fullQuery } = this.state
    const { startDateString, endDateString } = this.props.reportFilterStore!

    return (
      <>
        <div className='rounded background-white'>
          <div className='p-3'>
            <div>
              <b>Purchase orders</b>
            </div>
            <div className='text-muted'>Based on complete dates</div>

            <div className='mt-2'>
              {fullQuery ? (
                <QueryRenderer
                  query={fullQuery}
                  cubejsApi={getCubeAPI(this.props.companyId)}
                  render={this.renderChart}
                />
              ) : (
                <Skeleton active />
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
}
